/* eslint-disable no-console */
const setTooltipPosition = (btn, tooltip) => {
  let x = (btn.offsetLeft + btn.offsetWidth) - tooltip.offsetWidth;
  const caret = tooltip.querySelector('.tooltip-caret');
  if (x < 0) {
    // Offset caret
    caret.style.right = `${Math.abs(x) + 5}px`;
    // Reset x to 0
    x = 0;
  } else {
    caret.removeAttribute('style');
  }
  const y = btn.offsetTop - (tooltip.offsetHeight + 12);
  tooltip.style.left = `${x}px`;
  tooltip.style.top = `${y}px`;
};

const hideTooltip = (target) => {
  const btn = target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  if (btn.getAttribute('disabled') !== null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  btn.classList.remove('is-active');
  tooltip.classList.remove('show');
};

const hideOpenTooltips = () => {
  const tooltipBtns = document.querySelectorAll('[data-tooltip-id].is-active');
  for (let i = 0; i < tooltipBtns.length; i++) { /* eslint-disable-line no-plusplus */
    hideTooltip(tooltipBtns[i]);
  }
};

const showTooltip = (target) => {
  const btn = target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  if (btn.getAttribute('disabled') !== null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  hideOpenTooltips();
  btn.classList.add('is-active');
  tooltip.classList.add('show');
  setTooltipPosition(btn, tooltip);
};

const toggleTooltip = (target) => {
  const btn = target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  if (btn.getAttribute('disabled') !== null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  if (tooltip.classList.contains('show')) {
    btn.classList.remove('is-active');
    tooltip.classList.remove('show');
  } else {
    hideOpenTooltips();
    btn.classList.add('is-active');
    tooltip.classList.add('show');
    setTooltipPosition(btn, tooltip);
  }
};

let collectedEvents = [];

const selectEventHandler = () => {
  setTimeout(() => {
    // If click present, route to click event
    let active = collectedEvents.find(item => item.type === 'click');
    if (active) {
      toggleTooltip(active.target);
    } else {
      // Otherwise, use last event in array
      active = collectedEvents[collectedEvents.length - 1];
      if (active.type === 'mouseover' || active.type === 'focus') {
        showTooltip(active.target);
      } else if (active.type === 'mouseout' || active.type === 'blur') {
        hideTooltip(active.target);
      }
    }
    collectedEvents = [];
  }, 250);
};

const manageTooltipEvents = (event) => {
  const { target, type } = event;
  // Ignore if button is disabled
  if (target.getAttribute('disabled')) {
    return;
  }
  if (collectedEvents.length === 0) {
    selectEventHandler();
  }
  collectedEvents.push({
    target,
    type,
  });
};

const addTooltipEventHandlers = (btn) => {
  btn.addEventListener('click', manageTooltipEvents);
  btn.addEventListener('mouseover', manageTooltipEvents);
  btn.addEventListener('mouseout', manageTooltipEvents);
  btn.addEventListener('focus', manageTooltipEvents);
  btn.addEventListener('blur', manageTooltipEvents);
};

const addTooltipsOnPageLoad = () => {
  const tooltipBtns = document.querySelectorAll('[data-tooltip-id]');
  if (tooltipBtns.length === 0) {
    return;
  }
  for (let i = 0; i < tooltipBtns.length; i++) { /* eslint-disable-line no-plusplus */
    addTooltipEventHandlers(tooltipBtns[i]);
  }
};

const addNewTooltipsToButtonGroup = (options) => {
  const { btns } = options;
  if (btns.length === 0) {
    return;
  }
  for (let i = 0; i < btns.length; i++) { /* eslint-disable-line no-plusplus */
    addTooltipEventHandlers(btns[i]);
  }
};

const addNewTooltipToButton = (options) => {
  const { btn } = options;
  addTooltipEventHandlers(btn);
};

export {
  addNewTooltipToButton,
  addNewTooltipsToButtonGroup,
  addTooltipsOnPageLoad,
};
/* eslint-enable no-console */
